@use '../../styling/colors.scss' as *;
@use '../../styling/typography.scss' as *;

.ExecutionDot {
  position: relative;
  font-size: 16px;
  color: transparent;
  padding: 0;
  cursor: pointer;
  background: $theme-color-background;
  width: 24px;
  height: 24px;
  display: grid;
  place-items: center;
  border: 1px solid $theme-color-divider;

  &:first-child {
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
  }

  &:last-child {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }

  // overlap sibling boxes by 1px to give the visual of only 1px divider between boxes
  + #{&} {
    margin-left: -1px;
  }

  &:active,
  &:focus {
    outline: none;
  }

  &:hover {
    background-color: $color-secondary-button-hover;
  }

  &[aria-selected='true']::after {
    bottom: -22px;
    color: $theme-color-tooltip;
    content: '\002228'; // http://www.fileformat.info/info/unicode/char/2228/index.htm
    font-size: 22px;
    left: 0;
    position: absolute;
    transform: scaleY(0.5);
    width: 100%;
  }

  .tooltip {
    font-size: 0;
    position: absolute;
  }

  svg {
    display: block;
  }

  &[aria-selected='false']:hover .tooltip {
    @extend %font-family-primary;

    position: absolute;
    color: $color-white;
    font-size: $font-size-normal;
    padding: 0.5em 1em;
    background: $theme-color-tooltip;
    top: 100%;
    white-space: nowrap;
    border-radius: 5px;
    z-index: 1;
    transform: translateY(5px) translateX(-50%);

    &::after {
      // The triangle
      content: '';
      position: absolute;
      top: -5px;
      left: 50%;
      width: 0;
      height: 0;
      border-left: 5px solid transparent;
      border-right: 5px solid transparent;
      border-bottom: 5px solid $theme-color-tooltip;
      margin-left: -5px;
    }
  }
}
